import { centsToBRL, numberToCents, parseMoneyToNumber } from '../../lib/masks';

const DEFAULT_CLASS =
  'mt-1 w-full rounded-lg border border-mbc-line bg-mbc-panel2 px-3 py-2 text-sm text-white focus:border-mbc-orange focus:outline-none';

interface MoneyInputProps {
  /** Valor em reais (ex.: 143324.61). */
  value: number;
  /** Recebe o novo valor em reais. */
  onChange: (n: number) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  title?: string;
  onBlur?: () => void;
}

/**
 * Input de valor monetário estilo "caixa eletrônico": o usuário digita apenas
 * dígitos, que preenchem os centavos da direita para a esquerda. Exibe sempre
 * "R$ 1.433,24" formatado em pt-BR.
 */
export function MoneyInput({ value, onChange, className, placeholder, disabled, title, onBlur }: MoneyInputProps) {
  const display = `R$ ${centsToBRL(numberToCents(value))}`;
  return (
    <input
      type="text"
      inputMode="numeric"
      value={display}
      onChange={e => onChange(parseMoneyToNumber(e.target.value))}
      onBlur={onBlur}
      className={className ?? DEFAULT_CLASS}
      placeholder={placeholder}
      disabled={disabled}
      title={title}
    />
  );
}
